import "./Checkbox.scss";
import { generateUniqueId } from "../../../helpers/generateUniqueId";
import { useState } from "preact/hooks";
import Preact, { cloneElement, toChildArray, h} from "preact";
import { forwardRef } from "preact/compat";

export const Checkbox = forwardRef((props, forwardedRef) => {
  const {
    checked: controlledChecked,
    defaultChecked,
    onCheckedChange,
    children,
    ...inputProps
  } = props;

  const checkboxId = generateUniqueId();

  const [internalChecked, setInternalChecked] = useState(
    controlledChecked ?? defaultChecked ?? false,
  );

  const handleChange = (event) => {
    const newChecked = event.target.checked;
    setInternalChecked(newChecked);
    if (onCheckedChange) {
      onCheckedChange(newChecked);
    }
  };

  const finalChecked =
    controlledChecked !== undefined ? controlledChecked : internalChecked;

  return (
    <div className="hf8203182hdosk3j-checkbox-wrapper">
      <input
        ref={forwardedRef}
        type="checkbox"
        role="checkbox"
        checked={finalChecked}
        aria-checked={finalChecked ? "true" : "false"}
        onChange={handleChange}
        {...inputProps}
        id={checkboxId}
      />
      {toChildArray(children).map((child) =>
        cloneElement(child, { htmlFor: checkboxId }),
      )}{" "}
    </div>
  );
});

Checkbox.displayName = "Checkbox";

export const CheckboxIndicator = forwardRef((props, forwardedRef) => {
  const { children, ...restProps } = props;

  return (
    <label role="label" htmlFor={props.for} ref={forwardedRef} {...restProps}>
      {children}
    </label>
  );
});

CheckboxIndicator.displayName = "CheckboxIndicator";
